import { HTMLAttributes, ReactNode, useContext } from 'react';

import { twMerge } from 'tailwind-merge';

import { ModalContext, SIZES } from './context';
import { ModalButton } from './ModalButton';
import { ModalClose } from './ModalClose';

interface ModalFooterProps extends HTMLAttributes<HTMLDivElement> {
  readonly buttons?: ReactNode;
  readonly onCancel?: (() => void) | boolean | string;
}

function ModalFooter({ children, buttons, className, onCancel, ...props }: ModalFooterProps) {
  const { size } = useContext(ModalContext);

  return (
    <div
      {...props}
      className={twMerge(
        'flex items-center border-t border-neutral-300 bg-neutral-50 font-normal text-neutral-700 shadow-[0_0_4px_0_rgba(0,0,0,.15)]',
        SIZES[size].footer,
        className,
      )}
    >
      {children}
      {onCancel ? (
        <ModalClose asChild>
          <ModalButton
            variant="secondary"
            onClick={typeof onCancel === 'boolean' || typeof onCancel === 'string' ? undefined : onCancel}
            className="ml-auto"
          >
            {typeof onCancel === 'string' ? onCancel : 'Cancel'}
          </ModalButton>
        </ModalClose>
      ) : null}
      {buttons}
    </div>
  );
}

export { ModalFooter };
